import HTTP from '@/api/HTTP';
import contratServerTableDataTransformer
  from '@/services/baux/contrat/contratServerTableDataTransformer';

const URL_BASE = 'patri/Contrat/';

export async function create(contrat) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', contrat);
  return response;
}

export async function get(idContrat) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idContrat } });
  return response;
}

export async function update(contrat) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', contrat);
  return response;
}

export async function getAll(data) {
  const inputServer = contratServerTableDataTransformer(data);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function generationEcheancier(data) {
  const response = await HTTP.post(URL_BASE + 'PEcheancierGenerationAsync', data);
  return response;
}

export async function saveEcheancier(params) {
  const response = await HTTP.post(URL_BASE + 'SauvegardeEcheancierAsync', params);
  return response;
}

export async function cloture(id, dateCloture, isDeleteEchance) {
  const response = await HTTP.post(URL_BASE + 'ClotureAsync', { id, dateCloture, isDeleteEchance });
  return response;
}

export async function reactiver(id) {
  const response = await HTTP.post(URL_BASE + 'ReactiverAsync', { id });
  return response;
}

export async function reconductionContrat(listContratAReconduire) {
  const response = await HTTP.post(URL_BASE + 'ReconductionContratAsync', listContratAReconduire);
  return response;
}

export async function brouillon2Contrat(id) {
  const response = await HTTP.post(URL_BASE + 'Brouillon2ContratAsync', { id });
  return response;
}

export async function deleteContrat(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllContratAsync', ids);
  return response;
}

export async function createAll(params) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', params);
  return response;
}

export async function indexation(payload) {
  const response = await HTTP.post(URL_BASE + 'IndexationAsync', payload);
  return response;
}

export async function ajoutSecteurAsync(params) {
  const response = await HTTP.post(URL_BASE + 'AjoutSecteurAsync', params);
  return response;
}

export async function updateEtatRenouvellements(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateEtatRenouvellementAllAsync', params);
  return response;
}
